import { render, staticRenderFns } from "./CustomerOrderModeTakeAway.vue?vue&type=template&id=cc0bba56&scoped=true"
import script from "./CustomerOrderModeTakeAway.vue?vue&type=script&lang=js"
export * from "./CustomerOrderModeTakeAway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0bba56",
  null
  
)

export default component.exports